import React from 'react';
import { Images } from '../../app-constants';
import ImageIcon from './image-icon';

const SHTag = () => <ImageIcon src={Images.TagBlue} alt="sh-tag-icon/" />;

export default SHTag;
